/* eslint-disable react/prop-types */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';

import _ from 'lodash';
import metadata from './DriversListComponent.metadata.json5';
import './DriversListComponent.messages';
import styles from './DriversListComponent.module.scss';

const DRIVER_COURSES_IDENTIFIERS = ['PADefensiveDriver_ML', 'PADriverAccidentPrevention_ML', 'PADriversRoleModiferPreventionCourse_ML', 'PADefensiveDriver_Ext', 'PAMatureDriver_Ext', 'PADriverTrainingCourse_Ext'];


function DriversListComponent(props) {
    const { paModel, isPrimaryVehicleReqState, state, isFieldDefaultedByHVQ, isPolicyChange, refreshData, showErrors } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const driverTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const { isVehicleEligibleForAccidentPrevention } = MLDriverVehicleUtil();
    const vehicles = paModel.vehicles[0];
    
    let ratedDrivers;
    let vehiclesEligibleAsPrimaryVehicles;
    let hasPrimaryVehicleRequiredDriver;

    if (paModel !== undefined) {
        ratedDrivers = paModel.drivers.filter((driver) => {
            return driver.type_ML === driverTypeList.getCode('rated').code;
        });
        vehiclesEligibleAsPrimaryVehicles = paModel.vehicles.filter((vehicle) => isVehicleEligibleForAccidentPrevention(vehicle));
        hasPrimaryVehicleRequiredDriver = ratedDrivers.some((driver) => driver.showPrimaryVehicleQuestion);
    }

    const setPrimaryVehicleQuestionAvailable = useCallback((driver) => {
        const driverModifiers = driver.driverModifiers_ML;
        // eslint-disable-next-line no-param-reassign
        driver.showPrimaryVehicleQuestion = true;
        driverModifiers.isPrimaryVehicleRequired_ML = true;
        if (driverModifiers.primaryVehicleFixedId === 0) {
            driverModifiers.primaryVehicleFixedId = undefined;
        }
    }, []);

    const isDefensiveDriverCourseTaken = useCallback((driver) => {
        const driverModifiers = driver?.driverModifiers_ML;
        const paDefensiveDriverMod = driverModifiers?.modifiers?.find((mod) => DRIVER_COURSES_IDENTIFIERS.includes(mod.codeIdentifier_ML));
        return paDefensiveDriverMod && paDefensiveDriverMod.chosenTermValue === 'true';
    }, []);

    const sortVehiclesByFixedId = useCallback((a, b) => {
        if (!a.fixedId) {
            return 1;
        }
        if (!b.fixedId) {
            return -1;
        }
        return a.fixedId - b.fixedId;
    }, []);

    const hasMoreThanOneBridgedEligibleVehicle = () => {
        return vehiclesEligibleAsPrimaryVehicles.filter((vehicle) => vehicle.bridgedFromHVQ_ML === true).length > 1;
    };

    const primaryVehicleDefaultedByHVQ = (accessorCode) => {
        return !!isFieldDefaultedByHVQ
            && hasMoreThanOneBridgedEligibleVehicle()
            && isFieldDefaultedByHVQ(accessorCode);
    };

    const defaultPrimaryVehicle = (driver, vehicle) => {
        driver.showPrimaryVehicleQuestion = false;
        const driverModifiersVM = driver.driverModifiers_ML;
        driverModifiersVM.isPrimaryVehicleRequired_ML = true;
        driverModifiersVM.primaryVehicleFixedId = vehicle.getFixedId();
    };

    if (vehiclesEligibleAsPrimaryVehicles?.length > 0) {
        vehiclesEligibleAsPrimaryVehicles.sort(sortVehiclesByFixedId);
        if (isPrimaryVehicleReqState) {
            if (vehiclesEligibleAsPrimaryVehicles.length === 1) {
                // Default if only one eligible vehicle, do not show question
                ratedDrivers.forEach((driver) => {
                    if (isDefensiveDriverCourseTaken(driver)) {
                        defaultPrimaryVehicle(driver, vehiclesEligibleAsPrimaryVehicles[0]);
                    }
                });
            } else if (state === 'NJ' && ratedDrivers.length === 1) {
                // always show question when 1 driver and more than 1 vehicle in NJ, regardless of defensive driver course taken
                setPrimaryVehicleQuestionAvailable(ratedDrivers[0]);
            } else {
                ratedDrivers.forEach((driver) => {
                    if (isDefensiveDriverCourseTaken(driver) && vehiclesEligibleAsPrimaryVehicles.length > 0) {
                        setPrimaryVehicleQuestionAvailable(driver);
                    }
                });
            }
        }
    } else {
        ratedDrivers.forEach((driver) => {
            if (isDefensiveDriverCourseTaken(driver)) {
                driver.showPrimaryVehicleQuestion = false;
                const driverModifiersVM = driver.driverModifiers_ML;
                driverModifiersVM.isPrimaryVehicleRequired_ML = true;
                driverModifiersVM.primaryVehicleFixedId = vehicles.fixedId;
            }
        });
    }
    
    const generatedOverrides = () => {
        if (ratedDrivers) {
            const sectionOverrides = ratedDrivers.map((driver, index) => {
                return {
                    [`driverName${index}`]: {
                        content: driver.person.displayFullName_Ext
                    },
                    [`primaryVehicleQuestionContainer${index}`]: {
                        visible: !!driver.showPrimaryVehicleQuestion
                    },
                    [`primaryVehicleQuestions${index}`]: {
                        content: driver.person.displayName,
                        availableValues: vehiclesEligibleAsPrimaryVehicles
                       .filter((vehicle) => {
                         if (state === 'OR') {
                           return vehicle.primaryUse === 'pleasure';
                          }
                          else if(state==='ND' || state==='SC'){
                           return vehicle.primaryUse !=='storage_np';
                          }
                        return true;
                        })
                       .map((vehicle) => {
                        return {
                          code: vehicle.fixedId,
                          name: vehicle.getYearMakeModelNameML(),
                        };
                        }),
                        value: _.get(driver, 'driverModifiers_ML.primaryVehicleFixedId'),
                        onValueChange: (value) => {
                            _.set(driver, 'driverModifiers_ML.primaryVehicleFixedId', value);
                            refreshData();
                        }
                    },
                    [`vehicleHVQNotification${index}`]: {
                        visible: primaryVehicleDefaultedByHVQ('primaryVehicleFixedId')
                    }
                };
            });

            return Object.assign({}, ...sectionOverrides);
        }
        return {};
    };


    const overrideProps = {
        componentContainer: {
            visible: !(isPolicyChange && !hasPrimaryVehicleRequiredDriver)
        },
        driversList: {
            data: ratedDrivers
        },
        ...generatedOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            onModelChange={refreshData}
            classNameMap={styles}
            showErrors={showErrors}
        />
    );
}


DriversListComponent.propTypes = {
    paModel: PropTypes.shape({}).isRequired,
    isPrimaryVehicleReqState: PropTypes.bool.isRequired,
    state: PropTypes.string.isRequired,
    refreshData: PropTypes.func.isRequired,
    isFieldDefaultedByHVQ: PropTypes.func,
    isPolicyChange: PropTypes.bool
};

DriversListComponent.defaultProps = {
    isFieldDefaultedByHVQ: undefined,
    isPolicyChange: false
}

export default DriversListComponent;
